import Vue from 'vue';
import axios from 'axios';
import * as types from './mutation-types';

export default {
  [types.SET_ACCOUNT](state, payload) {
    state.account = payload;
  },
  [types.SET_CUSTOMER](state, payload) {
    state.customer = payload;
  },
  [types.SET_AUTH_SUCCESS](state, token) {
    localStorage.setItem('token', `${token}`);
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    state.token = token;
  },
  [types.SET_ERROR](state, payload) {
    const { error, message } = payload;
    state.errorCode = error;
    state.errorMessage = message;
    state.isError = true;
  },
  [types.RESET_AUTH](state) {
    localStorage.removeItem('token');
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common['x-ck-mode'];
    state.token = null;
  },
  [types.CLEAR_STATE](state) {
    state.account = {};
  },
  [types.UPDATE_PAYMENT_STATUS](state, payload) {
    const { type, status, invoiceId, amountPaid } = payload;

    if (type === 'paymentIntent' && state.account?.dunning?.paymentIntent) {
      // Update PaymentIntent status
      Vue.set(state.account.dunning.paymentIntent, 'status', status);
    } else if (type === 'invoice' && state.account?.invoices && invoiceId) {
      // Update invoice status in the invoices array
      const invoiceIndex = state.account.invoices.findIndex((i) => i.invoice === invoiceId);
      if (invoiceIndex !== -1) {
        Vue.set(state.account.invoices[invoiceIndex], 'status', status);
        if (amountPaid !== undefined) {
          Vue.set(state.account.invoices[invoiceIndex], 'amountPaid', amountPaid);
        }
      }
      // Also update dunning.invoice if it matches
      if (state.account.dunning?.invoice?.invoiceId === invoiceId) {
        Vue.set(state.account.dunning.invoice, 'status', status);
      }
    }
  },
};
